import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async calculate({ commit }, payload) {
    const res = await apiService.post(route('member.center_optimization.calculate'), payload)
    if (res.success && res.data) {
      return res.data
    }
    return false
  },
}

export default {
  state,
  mutations,
  actions,
}
